import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

export default function createNumberFormatter(locale: Bcp47Locale) {
  return (value: number, options: Intl.NumberFormatOptions = {}) =>
    Intl.NumberFormat(locale, options).format(value)
}
